import gsap from "gsap";

export default function animationsHero() {
  let bg = $('.hero__bg');
  let content = $('.hero__content');
  if (bg.length > 0) {
    gsap.to(bg, {delay: 0.5, opacity: 1, duration: 0.3, onComplete: () => {
      gsap.to(bg, {delay: 1.5, opacity: 0, duration: 0.3, onComplete: () => {
        gsap.to(content, {delay: 0.3, opacity: 1, duration: 0.5});
      }});
    }});
  }
}